<div [ngClass]="{ 'subscription-bar-visible': subscriptionStatusBarVisible() }" class="d-flex flex-column flex-root">
    @if (theme == 'default') {
        <default-layout></default-layout>
    }
    @if (theme == 'theme2') {
        <theme2-layout></theme2-layout>
    }
    @if (theme == 'theme3') {
        <theme3-layout></theme3-layout>
    }
    @if (theme == 'theme4') {
        <theme4-layout></theme4-layout>
    }
    @if (theme == 'theme5') {
        <theme5-layout></theme5-layout>
    }
    @if (theme == 'theme6') {
        <theme6-layout></theme6-layout>
    }
    @if (theme == 'theme7') {
        <theme7-layout></theme7-layout>
    }
    @if (theme == 'theme8') {
        <theme8-layout></theme8-layout>
    }
    @if (theme == 'theme9') {
        <theme9-layout></theme9-layout>
    }
    @if (theme == 'theme10') {
        <theme10-layout></theme10-layout>
    }
    @if (theme == 'theme11') {
        <theme11-layout></theme11-layout>
    }
</div>

<kt-scroll-top></kt-scroll-top>

<loginAttemptsModal #loginAttemptsModal></loginAttemptsModal>
@if (!installationMode) {
    <linkedAccountsModal #linkedAccountsModal (modalClose)="getRecentlyLinkedUsers()"></linkedAccountsModal>
}
<userDelegationsModal #userDelegationsModal></userDelegationsModal>
<changePasswordModal #changePasswordModal></changePasswordModal>
<changeProfilePictureModal #changeProfilePictureModal></changeProfilePictureModal>
<mySettingsModal #mySettingsModal (modalSave)="onMySettingsModalSaved()"></mySettingsModal>
<notificationSettingsModal #notificationSettingsModal></notificationSettingsModal>

<commonLookupModal #userLookupModal (itemSelected)="chatBarComponent.addFriendSelected($event)"></commonLookupModal>
@if (!installationMode && isQuickThemeSelectEnabled) {
    <theme-selection-panel #themeSelectionPanelComponent></theme-selection-panel>
}
@if (IsSessionTimeOutEnabled) {
    <session-timeout #sessionTimeout></session-timeout>
}
